import React, { FC } from 'react'
import { Accordion } from '@mtsdengi/ui-kit'
import { useToggleAccordionHandler } from '@mtsdengi/common'
import { TFaq, TFaqItem } from '../../types'
import { Styled } from './styled'

type TInnerAccordion = Pick<TFaq, 'onExpandQuestion' | 'onCollapseQuestion'> & {
  items: TFaqItem[]
}

export const InnerAccordion: FC<TInnerAccordion> = ({
  items,
  onExpandQuestion: onOpen,
  onCollapseQuestion: onClose,
}) => {
  const { toggleAbleItems, toggleAccordionHandler } = useToggleAccordionHandler({
    items,
    onOpen,
    onClose,
  })

  return (
    <Styled.TabletMobAccordionWrapper>
      <Accordion domMounted variant="violet" items={toggleAbleItems} onToggle={toggleAccordionHandler} />
    </Styled.TabletMobAccordionWrapper>
  )
}
